import initialState from "./initial.values";

const rootReducer: number | string | boolean | any = (
  state = initialState,
  action: number | string | boolean | any
) => {
  switch (action.type) {
    case "MOBILE_SIDEBAR":
      return { ...state, mobileSidebar: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
